module.exports = __webpack_public_path__ + "img/goods9_1.9ab15320.jpg";